/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
// NOTE: This file is auto-generated by svg-to-react.js. Direct changes to this
// file will be lost in future runs of the generator.
import * as React from 'react';
import { BaseIcon, IconProps } from './BaseIcon';

const GlobeIconImpl: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="GlobeIcon_svg__feather GlobeIcon_svg__feather-globe"
    {...props}
  >
    <circle cx={12} cy={12} r={10} />
    <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
  </svg>
);

export const GlobeIcon = (props: IconProps) => (
  <BaseIcon Icon={GlobeIconImpl} {...props} />
);
